var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"quotes",attrs:{"title":"Quotes"}},[_c('button-group-view',{attrs:{"slot":"tools","actions":_vm._filter},slot:"tools",model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('button-view',{attrs:{"slot":"tools","label":_vm.edit ? 'Gem': 'Tilpas'},on:{"click":_vm.editClick},slot:"tools"}),_c('div',{staticClass:"layout"},[_c('date-picker-std-view',{staticClass:"date",attrs:{"status":_vm._monthStatus},on:{"browse":_vm.updateMonthStatus},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('perfect-scrollbar',{staticClass:"tasks",style:({
			//gridRow: search == '' ? '6' : '2 / 7',
			transition: 'grid-row 250ms'
		}),attrs:{"name":"task","tag":"div"}},[_c('transition-group',{attrs:{"name":"task","tag":"div"}},[_vm._l((_vm._tasks),function(task,i){return _c('div',{key:task.id,class:['task', 'move'],on:{"mouseenter":function($event){return _vm.$store.commit('hover', [task, 'right'])},"mouseleave":function($event){return _vm.$store.commit('hover', [null, 'right'])}}},[_c('div',{staticClass:"color",style:({ backgroundColor: _vm._types.hasOwnProperty(task.type) ? _vm._types[task.type].color : 'yellow' })}),_c('div',{staticClass:"name"},[_vm._v("#"+_vm._s(task.num)+" "+_vm._s(task.name == '' ? '-' : task.name))]),_c('div',{staticClass:"inst"},[_vm._l((_vm.getInstruction(task, 'store')),function(store,i){return _c('drag',{key:i,attrs:{"payload":{ type: 'store', data: {
							store: store.desc,
							task: task
						} }}},[_c('div',{staticClass:"title"},[_vm._v("Til lager")]),_c('div',{staticClass:"address"},[_vm._v(_vm._s(store.address))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(store.desc))])])}),_vm._l((_vm.getInstruction(task, 'extract')),function(extract,i){return _c('div',{key:i},[_c('div',{staticClass:"title"},[_vm._v("Fra lager")]),_c('div',{staticClass:"address"},[_vm._v(_vm._s(extract.address))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(extract.desc))])])}),(task.type == 'handling')?_c('div',[_vm._v(" "+_vm._s(task.remarks)+" ")]):_vm._e()],2)])}),(_vm._tasks == null)?_c('spinner-view'):_vm._e()],2)],1),_c('new-table-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.openSpot),expression:"openSpot"}],staticClass:"win",attrs:{"draggable":"storage","actions":[
			{
				name: 'onClose',
				icon: 'close'
			}
		],"columns":[
			{
				label: 'Placering',
				name: 'name',
				template: {
					name: 'profile',
					params: {
						photo: {
							data: '/images/icon-boxes.jpg'
						},
						name: {
							name: 'name'
						},
						title: {
							name: 'remarks'
						}
					}
				}
			}
		],"items":_vm.openSpot ? _vm.openSpot._embedded.storage : []},on:{"onClose":_vm.onClose,"itemClick":_vm.deleteStorage}}),_c('new-table-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.openUnit),expression:"openUnit"}],staticClass:"win",attrs:{"draggable":"storage","actions":[
			{
				name: 'onClose',
				icon: 'close'
			},
			{
				name: 'unplace',
				icon: 'arrow_up'
			}
		],"columns":[
			{
				label: _vm.openUnit ? _vm.openUnit.full_name : '',
				name: 'name',
				template: {
					name: 'profile',
					params: {
						photo: {
							data: '/images/icon-boxes.jpg'
						},
						name: {
							name: 'name'
						},
						title: {
							name: 'remarks'
						}
					}
				}
			}
		],"items":_vm.openUnit ? _vm.openUnit._embedded.storage : []},on:{"onClose":_vm.onClose,"unplace":function($event){return _vm.unplaceUnit()},"itemClick":_vm.deleteStorage}}),_c('storage-map-view',{staticClass:"map",attrs:{"edit":_vm.edit,"location":_vm.filter,"openSpot":_vm.openSpot,"openUnit":_vm.openUnit},on:{"newspot":_vm.newspot,"copyspot":_vm.copyspot,"onUnitClick":_vm.onUnitClick,"onSpotClick":_vm.onSpotClick,"spotDrop":_vm.spotDrop,"unitDrop":_vm.unitDrop,"update":_vm.update}}),_c('new-table-view',{staticClass:"list",attrs:{"draggable":"unit","columns":[
			{
				label: 'Ude af huset',
				name: 'name',
				template: {
					name: 'profile',
					params: {
						photo: {
							data: '/images/icon-crate.jpg'
						},
						name: {
							name: 'full_name'
						},
						title: {
							name: 'remarks'
						}
					}
				}
			}
		],"items":_vm._unplaced_units},on:{"itemClick":_vm.onUnitClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }